function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u30EC\\u30A4\\u30E4\\u30FC_2-2",
  "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M.5 27h18.16v2H.5zM19.047 6.15v.035a2.766 2.766 0 01-5.531 0V6.15H9.235v3.267A1.6 1.6 0 0010.852 11h10.863a1.6 1.6 0 001.617-1.583V6.15zM.5 13h18.16v2H.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M3.5 2h2v29h-2zM20.11 22.816l.506-.316-.506-.316-1.339-.837a2.77 2.77 0 01-5.253-1.162v-.035H9.235v3.267A1.6 1.6 0 0010.852 25H18.7v-1.3zM29.5 13V2h-2v11h2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.5 15h-9.8v5.2l3.689 2.3-3.689 2.306V30h9.8v-5.154L27.216 22.5l3.284-2.345zm-2 13h-5.8v-2.086l3.122-1.952 2.678 1.913zm0-8.874l-2.678 1.912-3.122-1.952V17h5.8z"
})));

var SvgPutawaymin = function SvgPutawaymin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPutawaymin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Putaway.min.1e47e57b.svg";
export { ForwardRef as ReactComponent };